// src/translations.js
export const translations = {
  ro: {
    menu_home: "Acasă",
    menu_cazare: "Spații de cazare",
    menu_locatie: "Locația",
    
    slide_1: "un spațiu modern, generos și plăcut",
    slide_2: "într-o livadă verde",
    slide_3: "mere în iulie, un hamac... bucurie în natură",
    slide_4: "ca odinioară la țară, alte ritmuri\nveșnicia s-a născut la sat",
    slide_5: "un sat frumos, cu oameni gospodari",
    slide_6: "două terase în spate, un foișor de unde putem admira turnul de cetate",
    slide_7: "turnul de cetate din Răchitova din sec XIV\nun obiectiv istoric, traseul până la el și perspectiva de sus sunt de neratat",
    slide_8: "diverse posibilități...",
    slide_9: "natura este frumoasă și acolo unde mâna omului gospodar intervine respectând tradițiile vremurilor",

    cazare_title: "Spații de Cazare și Relaxare",
    cazare_subtitle: "Un refugiu confortabil, gândit pentru liniștea ta și a familiei tale.",
    cazare_sec1_title: "Camere Luminoase pentru Familii",
    cazare_sec1_text: "Oferim camere spațioase, amenajate simplu și cu bun gust, perfecte pentru familii sau grupuri de prieteni. Fiecare cameră beneficiază de lumină naturală din belșug, iar unele dispun de ferestre panoramice cu vedere directă spre livada verde.",
    cazare_sec2_title: "Spații Comune Generoase",
    cazare_sec2_text: "Parterul este inima casei. Aici te așteaptă un living primitor dotat cu canapele confortabile și televizor, ideal pentru serile lungi de povești sau jocuri de societate.",
    cazare_sec3_title: "Terasă și Aer Liber",
    cazare_sec3_text: "Pentru serile calde de vară sau diminețile cu rouă, terasa noastră exterioară este locul perfect.",

    alt_5: "Cameră cu vedere panoramică",
    alt_10: "Cameră de familie cu paturi suprapuse",
    alt_14: "Cameră cu paturi suprapuse",
    alt_9: "Cameră twin",
    alt_6: "Detaliu pat suprapus",
    alt_11: "Baie modernă",
    alt_29: "Sală de mese generoasă",
    alt_27: "Zona de living cu canapea",
    alt_28: "Holul interior cu scară",
    alt_30: "Zona pentru copii",
    alt_26: "Terasa exterioară cu bănci și hamac",
    alt_spate2: "Foișor de grătar",

    locatie_title: "Locația noastră",
    locatie_subtitle: "Ne aflăm în comuna Răchitova, în partea de sud-vest a județului Hunedoara, la 65 km de municipiul Deva, în minunatul Ținut al Țării Hațegului. Un loc ferit de vuietul orașelor unde totul se află în echilibru cu natura.",
    locatie_attractions_title: "Atracții turistice din împrejurimi",
    locatie_card1_title: "Cetatea Răchitova",
    locatie_card1_text: "Monument istoric din secolul al XIV-lea. O aşezare retrasă din Ţara Haţegului, înconjurată de păduri şi dealuri. Cea mai mare mândrie a comunităţii este turnul medieval care veghează asupra satului.",
    locatie_card2_title: "Mănăstirea Prislop",
    locatie_card2_text: "Situată în apropierea satului Silvașu de Sus. Biserica mănăstirii, edificiu din secolul al XVI-lea, a fost declarată monument istoric. A fost zidită din temelie în anul 1564 de Zamfira.",
    locatie_card3_title: "Biserica Densuș",
    locatie_card3_text: "Biserica Densuș din județul Hunedoara este cea mai veche biserică de piatră din România unde încă se oficiază slujbe. Construită în secolul XIII, impresionează prin zidurile sale realizate din pietre și altare romane aduse de la Ulpia Traiana Sarmizegetusa.",
    locatie_map_title: "Cum ajungi la noi",

    menu_contact: "Contact",
    contact_title: "Contactează-ne",
    contact_subtitle: "Ai întrebări sau vrei să faci o rezervare? Scrie-ne un mesaj, iar noi îți vom răspunde în cel mai scurt timp.",
    contact_name: "Numele tău",
    contact_email: "Adresa de email",
    contact_message: "Mesajul tău",
    contact_send: "Trimite Mesajul",
    contact_success: "Mesajul a fost trimis cu succes! Te vom contacta în curând.",
    contact_error: "A apărut o eroare. Te rugăm să încerci din nou.",
  },
  en: {
    menu_home: "Home",
    menu_cazare: "Accommodation",
    menu_locatie: "Location",
    
    slide_1: "a modern, spacious and pleasant space",
    slide_2: "in a green orchard",
    slide_3: "apples in July, a hammock... joy in nature",
    slide_4: "like in the old days in the countryside, different rhythms\neternity was born in the village",
    slide_5: "a beautiful village with hardworking people",
    slide_6: "two terraces in the back, a gazebo from where we can admire the fortress tower",
    slide_7: "the fortress tower of Răchitova from the 14th century\na historical landmark, the route to it and the view from above are a must-see",
    slide_8: "various possibilities...",
    slide_9: "nature is beautiful where the hand of a hardworking person intervenes while respecting the traditions of old times",

    cazare_title: "Accommodation and Relaxation Spaces",
    cazare_subtitle: "A comfortable retreat, designed for your peace and your family's.",
    cazare_sec1_title: "Bright Rooms for Families",
    cazare_sec1_text: "We offer spacious rooms, simply and tastefully decorated, perfect for families or groups of friends. Each room enjoys plenty of natural light, and some feature panoramic windows with a direct view of the green orchard.",
    cazare_sec2_title: "Generous Common Spaces",
    cazare_sec2_text: "The ground floor is the heart of the house. Here, a welcoming living room equipped with comfortable sofas and a TV awaits you, ideal for long evenings of stories or board games.",
    cazare_sec3_title: "Terrace and Open Air",
    cazare_sec3_text: "For warm summer evenings or dewy mornings, our outdoor terrace is the perfect place.",

    alt_5: "Room with panoramic view",
    alt_10: "Family room with bunk beds",
    alt_14: "Room with bunk beds",
    alt_9: "Twin room",
    alt_6: "Bunk bed detail",
    alt_11: "Modern bathroom",
    alt_29: "Generous dining room",
    alt_27: "Living area with sofa",
    alt_28: "Interior hall with staircase",
    alt_30: "Children's play area",
    alt_26: "Outdoor terrace with benches and hammock",
    alt_spate2: "Barbecue gazebo",

    locatie_title: "Our Location",
    locatie_subtitle: "We are located in Răchitova commune, in the south-western part of Hunedoara county, 65 km away from Deva, in the wonderful land of Hațeg. A place sheltered from the roar of cities, where everything is in balance with nature.",
    locatie_attractions_title: "Tourist Attractions Nearby",
    locatie_card1_title: "Răchitova Fortress",
    locatie_card1_text: "A 14th-century historical monument. A secluded settlement in Hațeg Country, surrounded by forests and hills. The community's greatest pride is the medieval tower that watches over the village.",
    locatie_card2_title: "Prislop Monastery",
    locatie_card2_text: "Located near the village of Silvașu de Sus. The monastery church, a 16th-century building, was declared a historical monument. It was built from the ground up in 1564 by Zamfira.",
    locatie_card3_title: "Densuș Church",
    locatie_card3_text: "Densuș Church in Hunedoara county is the oldest stone church in Romania where services are still held. Built in the 13th century, it impresses with its walls made of stones and Roman altars brought from Ulpia Traiana Sarmizegetusa.",
    locatie_map_title: "How to reach us",

    menu_contact: "Contact",
    contact_title: "Contact Us",
    contact_subtitle: "Do you have questions or want to make a reservation? Send us a message and we will get back to you shortly.",
    contact_name: "Your Name",
    contact_email: "Email Address",
    contact_message: "Your Message",
    contact_send: "Send Message",
    contact_success: "Message sent successfully! We will contact you soon.",
    contact_error: "An error occurred. Please try again.",
  },
  de: {
    menu_home: "Startseite",
    menu_cazare: "Unterkunft",
    menu_locatie: "Standort",
    
    slide_1: "ein moderner, großzügiger und angenehmer Raum",
    slide_2: "in einem grünen Obstgarten",
    slide_3: "Äpfel im Juli, eine Hängematte... Freude in der Natur",
    slide_4: "wie einst auf dem Lande, andere Rhythmen\ndie Ewigkeit wurde im Dorf geboren",
    slide_5: "ein schönes Dorf mit fleißigen Menschen",
    slide_6: "zwei Terrassen im hinteren Bereich, ein Pavillon, von dem aus wir den Festungsturm bewundern können",
    slide_7: "der Festungsturm von Răchitova aus dem 14. Jahrhundert\nein historisches Ziel, der Weg dorthin und die Aussicht von oben sind unumgänglich",
    slide_8: "vielfältige Möglichkeiten...",
    slide_9: "die Natur ist wunderschön, wo die Hand eines fleißigen Menschen eingreift und die Traditionen alter Zeiten respektiert",

    cazare_title: "Unterkunfts- und Entspannungsräume",
    cazare_subtitle: "Ein komfortabler Rückzugsort, entworfen für Ihre Ruhe und die Ihrer Familie.",
    cazare_sec1_title: "Helle Zimmer für Familien",
    cazare_sec1_text: "Wir bieten geräumige Zimmer, die einfach und geschmackvoll eingerichtet sind, perfekt für Familien oder Gruppen von Freunden. Jedes Zimmer bietet viel Tageslicht und einige verfügen über Panoramafenster mit direktem Blick auf den grünen Obstgarten.",
    cazare_sec2_title: "Großzügige Gemeinschaftsräume",
    cazare_sec2_text: "Das Erdgeschoss ist das Herz des Hauses. Hier erwartet Sie ein gemütliches Wohnzimmer mit bequemen Sofas und einem Fernseher, ideal für lange Erzählabende oder Gesellschaftsspiele.",
    cazare_sec3_title: "Terrasse und Freiluft",
    cazare_sec3_text: "Für warme Sommerabende oder taufrische Morgenstunden ist unsere Außenterrasse der perfekte Ort.",

    alt_5: "Zimmer mit Panoramablick",
    alt_10: "Familienzimmer mit Etagenbetten",
    alt_14: "Zimmer mit Etagenbetten",
    alt_9: "Twin-Zimmer",
    alt_6: "Etagenbett-Detail",
    alt_11: "Modernes Badezimmer",
    alt_29: "Großzügiges Esszimmer",
    alt_27: "Wohnbereich mit Sofa",
    alt_28: "Innenflur mit Treppe",
    alt_30: "Kinderbereich",
    alt_26: "Außenterrasse mit Bänken und Hängematte",
    alt_spate2: "Grillpavillon",

    locatie_title: "Unser Standort",
    locatie_subtitle: "Wir befinden uns in der Gemeinde Răchitova im Südwesten des Kreises Hunedoara, 65 km von der Stadt Deva entfernt, im wunderschönen Land von Hațeg. Ein Ort geschützt vom Lärm der Städte, an dem alles im Einklang mit der Natur steht.",
    locatie_attractions_title: "Sehenswürdigkeiten in der Umgebung",
    locatie_card1_title: "Festung Răchitova",
    locatie_card1_text: "Ein historisches Denkmal aus dem 14. Jahrhundert. Eine abgelegene Siedlung im Land Hațeg, umgeben von Wäldern und Hügeln. Der größte Stolz der Gemeinde ist der mittelalterliche Turm, der über das Dorf wacht.",
    locatie_card2_title: "Prislop-Kloster",
    locatie_card2_text: "In der Nähe des Dorfes Silvașu de Sus gelegen. Die Klosterkirche, ein Gebäude aus dem 16. Jahrhundert, wurde zum historischen Denkmal erklärt. Sie wurde 1564 von Zamfira von Grund auf erbaut.",
    locatie_card3_title: "Densuș-Kirche",
    locatie_card3_text: "Die Densuș-Kirche im Kreis Hunedoara ist die älteste Steinkirche Rumäniens, in der noch Gottesdienste stattfinden. Im 13. Jahrhundert erbaut, beeindruckt sie durch ihre Mauern aus Steinen und römischen Altären aus Ulpia Traiana Sarmizegetusa.",
    locatie_map_title: "Wie Sie uns erreichen",

    menu_contact: "Kontakt",
    contact_title: "Kontaktiere uns",
    contact_subtitle: "Haben Sie Fragen oder möchten Sie reservieren? Schreiben Sie uns eine Nachricht und wir melden uns in Kürze bei Ihnen.",
    contact_name: "Dein Name",
    contact_email: "E-Mail-Adresse",
    contact_message: "Deine Nachricht",
    contact_send: "Nachricht senden",
    contact_success: "Nachricht erfolgreich gesendet! Wir werden Sie bald kontaktieren.",
    contact_error: "Es ist ein Fehler aufgetreten. Bitte versuche es erneut."
  }
};